import { Vector3 } from 'three';
class ThirdPersonCamera {
    constructor(camera) {
        this.camera = camera;
        this.camera = camera;
        this.currentPosition = new Vector3();
        this.currentLookingAtPostion = new Vector3();
        this.rotationX = 0;
        this.rotationY = 70;
        this.rotationZ = 140;
        this.currentCameraState = 0;
        this.cameraStates = [
            {
                x: 0,
                y: 70,
                z: 140,
            },
            {
                x: 90,
                y: 70,
                z: 0,
            },
            {
                x: 0,
                y: 70,
                z: -90,
            },
            {
                x: -90,
                y: 70,
                z: 0,
            },
        ];
        window.addEventListener('keydown', (event) => {
            if (event.key === 'r') {
                if (this.currentCameraState >= this.cameraStates.length - 1) {
                    this.currentCameraState = 0;
                }
                else {
                    this.currentCameraState++;
                }
            }
        });
    }
    setTracking(gamepiece) {
        this.gamePiece = gamepiece;
    }
    getCameraAngel(x, y, z) {
        return new Vector3(x, y, z).add(this.gamePiece.mesh.position);
    }
    getWorldDirection() {
        return this.camera.getWorldDirection(new Vector3());
    }
    update() {
        const offset = this.getCameraAngel(this.cameraStates[this.currentCameraState].x, this.cameraStates[this.currentCameraState].y, this.cameraStates[this.currentCameraState].z);
        const lookingAt = this.getCameraAngel(0, 0, 0);
        const lerpTime = 0.05;
        this.currentPosition.lerp(offset, lerpTime);
        this.currentLookingAtPostion.lerp(lookingAt, lerpTime);
        this.camera.position.copy(this.currentPosition);
        this.camera.lookAt(this.currentLookingAtPostion);
    }
}
export default ThirdPersonCamera;
